import React, { useEffect, useState } from 'react';
import { CheckValidInputs, MainCond, StepBody, StepFooter, TextField, Spinner, NumberField, CheckBox, ToggleGroup, Line, useInput, AutoComplete, LineSmall } from 'meitav-uikit';
import utils from 'utils';
import { UmbracoStep } from 'components/Umbraco/UmbracoContext';
import { isMobile } from "react-device-detect";
import './step22.scss';
import { Parser } from 'html-to-react';
import Footer from 'components/Footer';

import { setDataLayer, postData } from '../../../../../utils/Functions';
import { popupWin } from 'components/PopUps';


const { UmbracoUtills, rest } = utils;

export default function Step22({
  resource,
  model,
  setModel,
  setStep,
  step,
  resourceError,
  disable,
  nextText,
  dataList,
  setDataList
}) {

  const resourceStep = UmbracoStep(resource, `FirstSub3Step`);
  const [popupObj, setPopupObj] = useState("");

  const p = new Parser();

  const myCond = {
    onlyIsraeli: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorIsraeliOnly"),
      cond: (value) => !value,
    },
    isAmerican: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorIsraeliOnly"),
      cond: (value) => value,
    },
    zipCode: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorStringLength"),
      cond: (value) => value.toString().length !== 5 && value.toString().length !== 7,
    },
    maxLen7: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorStringLength"),
      cond: (value) => value.toString().length > 7,
    },
    house: {
      msg: UmbracoUtills.getValueByKey(resourceError, "errorCharacter"),
      cond: (value) => (value != "") && (!/\d/.test(value))

    }
  };
  const [showSpinner, setShowSpinner] = useState(false);
  const [showSpinnerMail, setShowSpinnerMail] = useState(false);
  const [cityChange, setCityChange] = useState(false);
  const [cityMailChange, setCityMailChange] = useState(false);
  const [streetChange, setStreetChange] = useState(false);
  const [streetMailChange, setStreetMailChange] = useState(false);

  const city = useInput(UmbracoUtills.getValueByKey(resourceStep, 'city'), null, [MainCond.empty]);
  const street = useInput(UmbracoUtills.getValueByKey(resourceStep, 'street'), null, [MainCond.empty]);
  const house = useInput(UmbracoUtills.getValueByKey(resourceStep, 'home'), model.mainUser?.house, [myCond.house]);
  const zipCode = useInput(UmbracoUtills.getValueByKey(resourceStep, 'zipCode'), model.mainUser?.zipCode, [MainCond.empty, myCond.zipCode]);
  const apartment = useInput(UmbracoUtills.getValueByKey(resourceStep, 'apartment'), model.mainUser?.apartment);
  const isMailElseWhere = useInput(UmbracoUtills.getValueByKey(resourceStep, 'isMailElseWhere'), model.mainUser?.isMailElseWhere);
  const cityMail = useInput(UmbracoUtills.getValueByKey(resourceStep, 'city'), null);
  const streetMail = useInput(UmbracoUtills.getValueByKey(resourceStep, 'street'), null);
  const houseMail = useInput(UmbracoUtills.getValueByKey(resourceStep, 'home'), model.mainUser?.houseMail);
  const zipCodeMail = useInput(UmbracoUtills.getValueByKey(resourceStep, 'zipCode'), model.mainUser?.zipCodeMail);
  const apartmentMail = useInput(UmbracoUtills.getValueByKey(resourceStep, 'apartment'), model.mainUser?.apartmentMail);

  const israeliResidency = useInput(UmbracoUtills.getParsedHtmlValueByKey(resourceStep, 'israeliResidency'), model.mainUser?.israeliResidency, [MainCond.empty, myCond.onlyIsraeli]);
  const israeliCitizenship = useInput(UmbracoUtills.getParsedHtmlValueByKey(resourceStep, 'israeliCitizenship'), model.mainUser?.israeliCitizenship, [MainCond.empty, myCond.onlyIsraeli]);
  const americanCitizenship = useInput(UmbracoUtills.getParsedHtmlValueByKey(resourceStep, 'americanCitizenship'), model.mainUser?.americanCitizenship, [MainCond.empty]);
  const americanTax = useInput(UmbracoUtills.getParsedHtmlValueByKey(resourceStep, 'americanTax'), model.mainUser?.americanTax, [MainCond.empty, myCond.isAmerican]);
  const foreignNonAmercanTax = useInput(UmbracoUtills.getParsedHtmlValueByKey(resourceStep, 'foreignNonAmercanTax'), model.mainUser?.foreignNonAmercanTax, [MainCond.empty, myCond.isAmerican]);
  const birthCountry = useInput(UmbracoUtills.getValueByKey(resourceStep, 'birthCountry'), model.mainUser?.birthCountry, [MainCond.empty]);
  const [countriesList, setCountriesList] = useState([]);
  const option = [{ text: "כן", value: true }, { text: "לא", value: false }];

  const [citiesList, setCitiesList] = useState(dataList.cities || []);
  const [adressList, setAdressList] = useState([]);
  const [streetList, setStreetList] = useState([]);
  const [adressMailList, setAdressMailList] = useState([]);
  const [streetMailList, setStreetMailList] = useState([]);
  const [noStreet, setNoStreet] = useState("");
  const [noStreetMail, setNoStreetMail] = useState("");
  useEffect(() => {
    let obj = {};
    obj.type = "message";
    obj.title = UmbracoUtills.getValueByKey(resourceStep, 'popUpAmericanTaxTitle');
    obj.specialText = p.parse(UmbracoUtills.getValueByKey(resourceStep, 'popUpAmericanTaxSubTitle'));
    obj.btnCancelText = UmbracoUtills.getValueByKey(resourceStep, 'popUpAmericanTaxSubmit');
    obj.btnCancelText = false;
    obj.closeLink = true;
    setPopupObj(obj);
  }, []);

  useEffect(() => {
    GetCitiesList();
  }, []);

  const GetCitiesList = async () => {

    if (citiesList.length == 0) {
      const result = await rest.get(`/api/general/GetCitiesList`);
      if (result.data !== null && result.data.length > 0) {
        const citiesListOptions = result.data.map((d) => ({
          value: d.Code,
          text: d.Description,
        }));

        let tmpList = dataList;
        tmpList.cities = citiesListOptions;
        setDataList(tmpList);
        localStorage.setItem('dataList', JSON.stringify(tmpList));

        setCitiesList(citiesListOptions);
      }
    }
  }

  useEffect(() => {
    if (citiesList.length) {
      if (model.mainUser.cityText) {
        var citytmp = citiesList.find((x) => x.text === model.mainUser.cityText);
        city.setValue(citytmp);
      }
      if (model.mainUser.cityMail) {
        var citytmp = citiesList.find((x) => x.text === model.mainUser.cityMail);
        cityMail.setValue(citytmp);
      }
    }
  }, [citiesList]);

  useEffect(() => {
    street.setConds([MainCond.empty]);
    if (noStreet) {
      street.setConds([MainCond.empty, MainCond.hebrewAndNum]);
    }
  }, [noStreet]);

  useEffect(() => {
    streetMail.setConds([MainCond.empty]);
    if (noStreetMail) {
      streetMail.setConds([MainCond.empty, MainCond.hebrewAndNum]);
    }
  }, [noStreetMail]);

  useEffect(() => {
    house.setConds([]);
    if (house.value) {
      house.setConds([myCond.house]);
    }
  }, [house.value]);

  useEffect(() => {
    houseMail.setConds([]);
    if (houseMail.value) {
      houseMail.setConds([myCond.house]);
    }
  }, [houseMail.value]);

  useEffect(() => {
    streetMail.setConds([]);
    houseMail.setConds([]);
    zipCodeMail.setConds([]);
    cityMail.setConds([]);
    apartmentMail.setConds([]);


    if (isMailElseWhere.value) {
      streetMail.setConds([MainCond.empty]);
      zipCodeMail.setConds([MainCond.empty, myCond.zipCode]);
      cityMail.setConds([MainCond.empty]);
      houseMail.setConds([myCond.house]);

    }
  }, [isMailElseWhere.value]);

  useEffect(() => {
    if (cityChange || (city.value && model.mainUser.cityText != city.value.text)) {
      setCityChange(true);
      street.setValue('');
      house.setValue('');
      zipCode.setValue('');
      apartment.setValue('');
    }
    if (!city.value) {
      setStreetList([]);
    } else {
      getStreetList(city.value.value);
    }
  }, [city.value]);

  useEffect(() => {
    if (cityMailChange || (cityMail.value && model.mainUser.cityMail != cityMail.value.text)) {
      setCityMailChange(true);
      streetMail.setValue('');
      houseMail.setValue('');
      zipCodeMail.setValue('');
      apartmentMail.setValue('');
    }
    if (!cityMail.value) {
      setStreetMailList([]);
    } else {
      getStreetMailList(cityMail.value.value);
    }
  }, [cityMail.value]);

  async function getStreetList(SelectedCity) {

    setNoStreet(false);
    setShowSpinner(true);

    const requestUrl = `/api/general/GetAddressDetailsByCity?prmCityID=${SelectedCity}`;
    const response = await rest.get(requestUrl);
    if (response) {
      const streetListTmp = response.data.streetList;

      if (streetListTmp != undefined && streetListTmp.length > 0) {
        setAdressList(response.data.addresses);
        const streetDetailsOptions = streetListTmp.map(d => ({
          value: d.StreetID,
          text: d.StreetDesc,
        }));
        setStreetList(streetDetailsOptions);
        if (model.mainUser.street) {
          var streettmp = streetDetailsOptions.find((x) => x.text === model.mainUser.street);
          street.setValue(streettmp);
        }
      } else {
        setNoStreet(true);
        if (model.mainUser.street) {
          street.setValue(model.mainUser.street);
        }
      }
      setShowSpinner(false);
    }
  }

  async function getStreetMailList(SelectedCity) {

    setShowSpinnerMail(true);
    setNoStreetMail(false);

    const requestUrl = `/api/general/GetAddressDetailsByCity?prmCityID=${SelectedCity}`;
    const response = await rest.get(requestUrl);
    if (response) {
      const streetListTmp = response.data.streetList;
      setAdressMailList(response.data.addresses);
      if (streetListTmp != undefined && streetListTmp.length > 0) {
        const streetDetailsOptions = streetListTmp.map(d => ({
          value: d.StreetID,
          text: d.StreetDesc,
        }));
        setStreetMailList(streetDetailsOptions);
        if (model.mainUser.streetMail != '') {
          var streettmp = streetDetailsOptions.find((x) => x.text === model.mainUser.streetMail);
          streetMail.setValue(streettmp);

        }
      } else {
        setNoStreetMail(true);
        if (model.mainUser.streetMail != '') {
          streetMail.setValue(model.mainUser.streetMail);
        }
      }
      setShowSpinnerMail(false);
    }
  }

  useEffect(() => {
    if (noStreet === "") return;

    if (streetChange ||
      (!noStreet && street.value && model.mainUser.street != street.value.text) ||
      (noStreet && model.mainUser.street != street.value)) {
      setStreetChange(true);
      house.setValue('');
      zipCode.setValue('');
      apartment.setValue('');
    }
  }, [street.value]);

  useEffect(() => {
    if (noStreetMail === "") return;

    if (streetMailChange ||
      (!noStreetMail && streetMail.value && model.mainUser.streetMail != streetMail.value.text) ||
      (noStreetMail && model.mainUser.streetMail != streetMail.value)) {
      setStreetMailChange(true);
      houseMail.setValue('');
      zipCodeMail.setValue('');
      apartmentMail.setValue('');
    }
  }, [streetMail.value]);


  const getZipCode = (val) => {


    const choose = adressList?.filter(e => e.StreetDesc === street.value.text && e.HouseNumber == val.target.value)[0];
    zipCode.setValue("");
    if (choose)
      zipCode.setValue(choose.ZipCode7 ? choose.ZipCode7 : choose.ZipCode5);
  }

  const getZipCodeMail = (val) => {
    // if(val!='')
    // houseMail.setConds(myCond.house);
    // else
    //houseMail.setConds();
    const choose = adressMailList?.filter(e => e.StreetDesc === streetMail.value.text && e.HouseNumber == val.target.value)[0];
    zipCodeMail.setValue("");
    if (choose)
      zipCodeMail.setValue(choose.ZipCode7 ? choose.ZipCode7 : choose.ZipCode5);
  }
  useEffect(() => {
    getCountries();
  }, []);

  const getCountries = async () => {
    const t = await rest.get(`/api/general/GetCountries`);
    const options = t.data.map(function (row) {
      return { value: row.CountryId, text: row.CountryName }
    })

    setCountriesList(options);
    //if(model.mainUser.birthCountry)
    let birthCountryTmp = model.mainUser?.birthCountry ? model.mainUser?.birthCountry : 'ישראל';
    birthCountry.setValue(options.find(x => x.text === birthCountryTmp))
  };


  useEffect(() => {
    if (israeliResidency?.value === false) {
      popupWin(popupObj);
    }
  }, [israeliResidency.value,popupObj]);

  useEffect(() => {
    if (israeliCitizenship.value === false) {
      popupWin(popupObj);
    }
  }, [israeliCitizenship.value,popupObj]);

  useEffect(() => {
    if (americanTax.value === true) {
      popupWin(popupObj);
    }
  }, [americanTax.value,popupObj]);

  useEffect(() => {
    if (foreignNonAmercanTax.value === true) {
      popupWin(popupObj);
    }
  }, [foreignNonAmercanTax.value,popupObj]);

  const handleNext = async () => {

    if (model.mainUser.street && !street.value)
      return;

    let tmpStep = model.mainUser?.asInvestPartner && model.mainUser?.commonBankAccount ? 23 : 31;
    if (disable) {

      setStep(tmpStep);
      return;
    }

    if (!CheckValidInputs([israeliCitizenship,americanCitizenship, israeliResidency, birthCountry,
      americanTax, foreignNonAmercanTax, city, street, house, apartment, zipCode, cityMail, streetMail, houseMail, zipCodeMail, apartmentMail])) {
      return;
    }
    setDataLayer("PM - private details", "/JoinPersonalDetails", "פרטי תושבות", "המשך מוצלח של שלב פרטי תושבות");

    let tmpModel = model;
    tmpModel.mainUser.israeliResidency = israeliResidency.value;
    tmpModel.mainUser.israeliCitizenship = israeliCitizenship.value;
    tmpModel.mainUser.americanCitizenship = americanCitizenship.value;
    tmpModel.mainUser.americanTax = americanTax.value;
    tmpModel.mainUser.foreignNonAmercanTax = foreignNonAmercanTax.value;
    tmpModel.mainUser.birthCountry = birthCountry?.value?.text;
    tmpModel.mainUser.cityText = city.value.text != undefined ? city.value.text : city.value;
    tmpModel.mainUser.street = street.value.text != undefined ? street.value.text : street.value;
    tmpModel.mainUser.zipCode = zipCode.value;
    tmpModel.mainUser.house = house.value;
    tmpModel.mainUser.apartment = apartment.value;
    tmpModel.mainUser.isMailElseWhere = isMailElseWhere.value;
    tmpModel.mainUser.cityMail = isMailElseWhere.value ? cityMail.value.text : "";
    tmpModel.mainUser.streetMail = isMailElseWhere.value ? (!noStreetMail ? streetMail.value.text : streetMail.value) : "";
    tmpModel.mainUser.houseMail = isMailElseWhere.value ? houseMail.value : "";
    tmpModel.mainUser.zipCodeMail = isMailElseWhere.value ? zipCodeMail.value : "";
    tmpModel.mainUser.apartmentMail = isMailElseWhere.value ? apartmentMail.value : "";

    tmpModel.currentStepID = 22;

    tmpModel.stepID = tmpStep;
    postData(tmpModel, setStep);
  };

  const handlePrev = async () => {
    if (model.mainUser.street && !street.value)
      return;
    setDataLayer("PM - Levels", "/JoinPersonalDetails", "חזור לשלב הקודם", "חזרה - " + step);


    let tmpModel = model;
    tmpModel.mainUser.israeliResidency = israeliResidency.value;
    tmpModel.mainUser.israeliCitizenship = israeliCitizenship.value;
    tmpModel.mainUser.americanCitizenship = americanCitizenship.value;
    tmpModel.mainUser.americanTax = americanTax.value;
    tmpModel.mainUser.foreignNonAmercanTax = foreignNonAmercanTax.value;
    tmpModel.mainUser.birthCountry = birthCountry?.value?.text;
    tmpModel.mainUser.cityText = city.value.text != undefined ? city.value.text : city.value;
    tmpModel.mainUser.street = street.value.text != undefined ? street.value.text : street.value;
    tmpModel.mainUser.zipCode = zipCode.value;
    tmpModel.mainUser.house = house.value;
    tmpModel.mainUser.apartment = apartment.value;
    tmpModel.mainUser.isMailElseWhere = isMailElseWhere.value;
    tmpModel.mainUser.cityMail = isMailElseWhere.value ? cityMail.value.text : "";
    tmpModel.mainUser.streetMail = isMailElseWhere.value ? (!noStreetMail ? streetMail.value.text : streetMail.value) : "";
    tmpModel.mainUser.houseMail = isMailElseWhere.value ? houseMail.value : "";
    tmpModel.mainUser.zipCodeMail = isMailElseWhere.value ? zipCodeMail.value : "";
    tmpModel.mainUser.apartmentMail = isMailElseWhere.value ? apartmentMail.value : "";
    setModel(tmpModel);
    setStep(21);
  };

  return (
    <div className='step22'>
      <StepBody>
        <AutoComplete fre id="birthCountry" disable={disable} {...birthCountry} options={countriesList} optionText="text" optionValue="value"
          onBlur={(e) => setDataLayer("PM - private details", "/JoinPersonalDetails", "פרטים אישיים", `עיר מגורים - ${e}`)} />
        <Line className='line'>
          <ToggleGroup id="israeliResidency" disable={disable} {...israeliResidency} options={option} direction={!isMobile ? "vertical" : ""}
            onBlur={(e) => setDataLayer("PM - private details", "/JoinPersonalDetails", "פרטי תושבות", `תושבת ישראל - ${e}`)} />

          <ToggleGroup id="israeliCitizenship" disable={disable} {...israeliCitizenship} options={option} direction={!isMobile ? "vertical" : ""}
            onBlur={(e) => setDataLayer("PM - private details", "/JoinPersonalDetails", "פרטי תושבות", `יש לך אזרחות ישראלית -  ${e}`)} />
          <ToggleGroup id="americanCitizenship" disable={disable} {...americanCitizenship} options={option} direction={!isMobile ? "vertical" : ""}
            onBlur={(e) => setDataLayer("PM - private details", "/JoinPersonalDetails", "פרטי תושבות", `יש לך אזרחות ארה"ב -  ${e}`)} />

        </Line>
        <Line className='line'>
          <ToggleGroup id="americanTax" disable={disable}  {...americanTax} options={option} direction={!isMobile ? "vertical" : ""}
            onBlur={(e) => setDataLayer("PM - private details", "/JoinPersonalDetails", "פרטי תושבות", `תושב ארה"ב לצורך מס -  ${e}`)} />
          <ToggleGroup id="foreignNonAmercanTax" disable={disable}  {...foreignNonAmercanTax} options={option} direction={!isMobile ? "vertical" : ""}
            onBlur={(e) => setDataLayer("PM - private details", "/JoinPersonalDetails", "פרטי תושבות", `תושב מדינה זרה לצורך מס -  ${e}`)} />

        </Line>
        <Line className='line'>
          <AutoComplete disable={disable} id="city" {...city} options={citiesList} optionValue="value" optionText="text"
            onBlur={(e) => setDataLayer("PM - private details", "/JoinPersonalDetails", "פרטי תושבות", `עיר מגורים -  ${e.text}`)}
          />
          {showSpinner ? <Spinner /> :
            <> {!noStreet ? <AutoComplete disable={disable} id="street" {...street} options={streetList} optionValue="value" optionText="text" />
              : <TextField disable={disable} id="street" {...street} />}</>}
        </Line>
        <Line className='step22 line'>
          <TextField id="house" {...house} disable={disable} onBlur={getZipCode} />
          <NumberField id="apartment" disable={disable}{...apartment} />
          <NumberField id="zipCode" disable={disable}{...zipCode} /></Line>
        <CheckBox id="isMailElseWhere" disable={disable}{...isMailElseWhere} onChange={() => isMailElseWhere.setValue(!isMailElseWhere.value)} />
        {isMailElseWhere.value && (
          <><Line className='line'>
            <AutoComplete id="cityMail" disable={disable} {...cityMail} options={citiesList} optionText="text" optionValue="value" />
            {showSpinnerMail ? <Spinner /> :
              <> {!noStreetMail ? <AutoComplete disable={disable} id="streetMail" {...streetMail} options={streetMailList} optionValue="value" optionText="text" />
                : <TextField id="streetMail" disable={disable} {...streetMail} />}</>} </Line>
            <Line className='step22 line'>
              <TextField id="houseMail" disable={disable} {...houseMail} onBlur={getZipCodeMail} />
              <NumberField id="apartmentMail" disable={disable} {...apartmentMail} />
              <NumberField id="zipCodeMail" disable={disable}{...zipCodeMail} />
            </Line>
          </>
        )}
      </StepBody>
      <StepFooter nextText={nextText}
        handleNext={handleNext} handlePrev={handlePrev} />
      <Footer text={p.parse(UmbracoUtills.getValueByKey(
        resourceStep,
        "mainText"
      ))}></Footer>
    </div>
  );
}
